import React, { useState, useEffect } from "react";
import { Link, useNavigate, Redirect, useLocation } from "react-router-dom";
import Cookies from "js-cookie";
import swal from "sweetalert";
import { login } from "../../Redux/Action/LoginAction/loginAction";
import { useDispatch } from "react-redux";
import { setItemLocalStorage } from "../../Utils/localStroge";
import { ANDROID_APP_LINK, IOS_APP_LINK, SIGN_UP_TYPE } from "../../Utils/constants";
import EyesOnIcon from "../../assets/images/show.png";
import EyesOffIcon from "../../assets/images/hide.png";
import "./login.css";
import { resendOtpApi } from "../../API/ApiService";
import { createUserWithEmailAndPassword, getAuth, signInWithEmailAndPassword } from "firebase/auth";
import { getDatabase, ref, set, update } from "firebase/database";
import { get, onValue, off } from "firebase/database";
import { database } from "../../Utils/firebaseConfig";
import { handleUuidAfterLogin } from '../../Utils/uuidHandler';

function Login() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const [showPassword, setShowPassword] = useState(false);
  const [checkedVal, setCheckedVal] = useState("Customer");

  useEffect(() => {
    if (location?.state?.checkedVal) {
      setCheckedVal(location.state.checkedVal)
    }
  }, [location])


  const [values, setValues] = useState({
    email: Cookies.get("email"),
    password: Cookies.get("password"),
  });

  const [errors, setErrors] = useState({
    email: "",
    password: "",
  });

  const [touched, setTouched] = useState({
    email: false,
    password: false,
  });

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!email) {
      return "Email is required";
    } else if (!emailRegex.test(email)) {
      return "Please enter a valid email address";
    }
    return "";
  };

  const validatePassword = (password) => {
    if (!password) {
      return "Password is required";
    } else if (password.length < 6) {
      return "Password must be at least 6 characters long";
    }
    return "";
  };

  function getPrefixedEmail(email) {
  const env = process.env.REACT_APP_ENV || process.env.NODE_ENV;

    if (env === "preprod") {
      return `preprod_${email}`;
    } else if (env === "staging") {
      return `stag_${email}`;
    } else {
      return email;
    }
  }

  const loginusingFirebase = async (userDetails) => {
    const auth = getAuth();
    const db = getDatabase();
    const userEmail = getPrefixedEmail(userDetails.email_id);
    try {
      const password = userDetails?.phone
      try {
        const userCredential = await signInWithEmailAndPassword(
          auth, 
          userEmail,
          password
        );
        
        const user = userCredential.user;
        const userRef = ref(db, `users/${user.uid}`);
        await update(userRef, {
          fcm_token: user?.accessToken || '',
          id: user.uid,
          name: userDetails?.userProfile?.name || '',
          profile_image: userDetails?.userProfile?.profile_image || '',
          user_uuid: userDetails?.user_uuid || '',
        });
          if (userDetails?.user_uuid) {
            try {
              const usersRef = ref(database, "users");
              const snapshot = await get(usersRef);
              if (snapshot.exists()) {
                let foundUserId = null;
                snapshot.forEach((child) => {
                  const userData = child.val();
                  if (userData.user_uuid && userData.user_uuid === userDetails.user_uuid) {
                    foundUserId = child.key;
                     const userChatsRef = ref(database, `users/${foundUserId}/chats`);
                      const unsubscribe = onValue(userChatsRef, (snapshot) => {
                        let totalUnread = 0;
                        const chats = snapshot.val();
                        
                        if (chats) {
                          Object.values(chats).forEach(chat => {
                            totalUnread += chat.unreadCount || 0;
                          });
                        }
                        localStorage.setItem("totalUnreadCount", totalUnread);
                      });
  
                      return () => {
                        off(userChatsRef);
                      };
                  }
                })
                if (!foundUserId) {
                  console.warn("No user found with user_uuid:", userDetails.user_uuid);
                }
              } else {
                // console.log("No users found in database");
              }
            } catch (error) {
              console.error("Error fetching user ID:", error);
            }
          }
      } catch (error) {
        console.error("Sign-in error:", error.code, error.message);
        
        if (error.code === "auth/user-not-found" || error.code === "auth/too-many-requests") {

          const userEmail = getPrefixedEmail(userDetails.email_id);

          console.log("Creating new user with email:", userEmail);

          const newUserCredential = await createUserWithEmailAndPassword(
            auth, 
            userEmail,
            password
          );
          const newUser = newUserCredential.user;
          const userRef = ref(db, `users/${newUser.uid}`);
          await set(userRef, {
            fcm_token: userDetails?.fcm_token || '',
            id: newUser.uid,
            name: userDetails?.userProfile?.name || '',
            profile_image: userDetails?.userProfile?.profile_image || '',
            user_uuid: userDetails?.user_uuid || '',
          });
          
        } else if (error.code === "auth/email-already-in-use") {
          console.error("Email already in use");
        } else if (error.code === "auth/invalid-email") {
          console.error("Invalid email format");
        }
      }
    } catch (error) {
      console.error("Firebase error:", error);
    }
  };

  const handleInputChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;

    setValues({
      ...values,
      [name]: value,
    });
    setErrors({
      ...errors,
      [name]: "",
    });
  };
  const handleBlur = (e) => {
    const name = e.target.name;

    setTouched({
      ...touched,
      [name]: true,
    });

    // Validate on blur
    if (name === "email") {
      setErrors({
        ...errors,
        email: validateEmail(values.email),
      });
    } else if (name === "password") {
      setErrors({
        ...errors,
        password: validatePassword(values.password),
      });
    }
  };
  // ======= submit Login request ==============
  const handleSubmit = async (e) => {
    e.preventDefault();
    e.stopPropagation();

    // Validate all fields
    const emailError = validateEmail(values.email);
    const passwordError = validatePassword(values.password);

    // Set all fields as touched
    setTouched({
      email: true,
      password: true,
    });

    // Update errors
    setErrors({
      email: emailError,
      password: passwordError,
    });

    // If there are errors, stop submission
    if (emailError || passwordError) {
      return;
    }

    let body = JSON.stringify({
      email: values.email,
      password: values.password,
      platform: "web",
      os_version: "0",
      app_version: "v.0.0",
      user_timezone: "GMT+5:30",
    });
    // // console.log("body--", body);
    try {
      const response = await dispatch(login(body));
      // Simple way
      const loginDataSuccess = response;
      if (loginDataSuccess) {
        if (loginDataSuccess?.data.status == 200) {
          if (loginDataSuccess?.data?.user?.is_deleted == 0) {
            const result = loginDataSuccess.data.user;
            setItemLocalStorage(
              "accessToken",
              loginDataSuccess.data.access_token
            );
            if (result.user_state === "0" && result.status == 0) {
              const res = await resendOtpApi();
              const loginDataSuccess = res;
              if (loginDataSuccess) {
                swal({
                  title: "OTP sent!",
                  text: "OTP sent to your email",
                  buttons: false,
                  icon: "success",
                  timer: 3000,
                });
              }
              navigate("/signinotp", { state: { forget_password: 0 } })
            } else {
              setItemLocalStorage(
                "refreshToken",
                loginDataSuccess.data.refresh_token
              );
              setItemLocalStorage("user_uuid", result?.user_uuid);
              setItemLocalStorage("id", result?.userProfile?.id);
              setItemLocalStorage("user", JSON.stringify(result));
              setItemLocalStorage('sign_in_type', checkedVal)
              // Handle UUID encoding and API call for both Customer and Business
              if (result?.user_uuid) {
                await handleUuidAfterLogin(result.user_uuid, result);
              }
              loginusingFirebase(result)
              if (result.user_state === "0") {
                navigate("/register");
              } else if (
                (result.user_state === "1" || result.user_state === "2") &&
                checkedVal === "Business"
              ) {
                navigate("/adbusinessdetails");
              } else {
                navigate(location?.state?.backRoute || "/")
              }
            }
          } else {
            swal({
              title: "Inactive User!",
              text: "User is either Inactive or Deleted",
              buttons: false,
              icon: "error",
              timer: 3000,
            });
          }
        } else {
          swal({
            title: "error!",
            text: "Please complete your business details from the mobile app and try again",
            buttons: false,
            icon: "error",
            timer: 3000,
          });
        }
      } else {
        swal({
          title: "error!",
          text: loginDataSuccess?.data?.message,
          buttons: false,
          icon: "error",
          timer: 3000,
        });
      }
    } catch (err) {
      // console.log(err);
    }
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const checkHandler = (event) => {
    setCheckedVal(event.target.value);
  };

  return (
    <>
      <div className="container login2">
        <div className="row login3">
          <div className="col-md-6 trust_sec">
            <h1>
              Your Trusted
              <br />
              Local Connection
              <br />{" "}
              <label
                style={{
                  color: "#349c52",
                  position: "relative",
                }}
              >
                Starts Here
                <img
                  src="images/green-suf.png"
                  className="key_feature_designg2"
                  alt=""
                  style={{ left: "3px" }}
                />
              </label>
            </h1>
            <div id="download_app">
              <div className="container login_download_app mt-1">
                <h6>
                  <img
                    src="images/suffixes3.svg"
                    className="suffixes3"
                    alt=""
                  />
                  Please Download and Install Brigiz App
                  <br />
                  to Explore More features{" "}
                  <img
                    src="images/green-suf2.png"
                    className="green-suf2"
                    style={{
                      width: "168px",
                      height: "32px",
                      marginLeft: "-158px",
                    }}
                    alt=""
                  />
                </h6>
              </div>
              <div className=" exp-download-btns mt-4">
                <button
                  onClick={() => window.open(ANDROID_APP_LINK, "_")}
                  style={{ background: "#292828" }}
                >
                  <div className="g_pay_container ">
                    <div className=" btn-img1">
                      <img src="images/play-button.svg" alt="" />
                    </div>
                    <div className=" btn-txt1">
                      <span>GET IT ON</span>
                      <p className="text-white m-0">Google Play</p>
                    </div>
                  </div>
                </button>
                <button
                  onClick={() => window.open(IOS_APP_LINK, "_")}
                  style={{ width: "180px", background: "#292828" }}
                >
                  <div className="g_pay_container">
                    <div className=" btn-img1">
                      <img src="images/apple.svg" />
                    </div>
                    <div className="col-md-9 btn-txt1">
                      <span>Download on the</span>
                      <p className="text-white m-0">App Store</p>
                    </div>
                  </div>
                </button>
              </div>
            </div>
          </div>
          <div className="col-md-6 form_screen">
            <div className="login_card bg-white p-5 mt-1">
              <div className="login_back_btn">
                {" "}
                <h4 className="login_form_label_2">Sign In Your Account</h4>
                <button
                  href="#"
                  style={{ verticalAlign: "text-bottom" }}
                  onClick={() => navigate(-1)}
                >
                  <img src="images/back.png" alt="" /> Back
                </button>
                {/* <span className='ms-2'>Back</span> */}
              </div>
              <form onSubmit={handleSubmit} className="login_form2">
                <div className="d-flex mt-4 row">
                  <div className="form-check col-md-6">
                    <input
                      type="radio"
                      className="form-check-input"
                      id="radio1"
                      name="optradio"
                      value="Customer"
                      onChange={checkHandler}
                      checked={checkedVal === "Customer"}

                    //   checked={checkedVal}
                    />
                    <label className="form-check-label2" htmlFor="radio1">
                      For Customer
                    </label>
                  </div>
                  <div className="form-check col-md-6">
                    <input
                      type="radio"
                      className="form-check-input"
                      id="radio2"
                      name="optradio"
                      value="Business"
                      onChange={checkHandler}
                      checked={checkedVal === "Business"}
                    />

                    <label className="form-check-label2" htmlFor="radio2">
                      For Business
                    </label>
                  </div>
                </div>
                <div className="form-group">
                  <label className="login_form_email2 mt-4 mb-2">
                    Email Address
                  </label>
                  <input
                    className={`login_form_input2 ${touched.email && errors.email ? "is-invalid" : ""
                      }`}
                    type="text"
                    name="email"
                    value={values.email}
                    onChange={handleInputChange}
                    onBlur={handleBlur}
                  />
                  {touched.email && errors.email && (
                    <div
                      className="error-message text-danger "
                      style={{ marginBottom: "14px" }}
                    >
                      {errors.email}
                    </div>
                  )}
                </div>
                <label className="login_form_email2 my-2">Password</label>
                <div className="password-input-container">
                  <input
                    className="login_form_input2"
                    type={showPassword ? "text" : "password"}
                    name="password"
                    onChange={handleInputChange}
                  />
                  <button
                    type="button"
                    className="password-toggle-btn bg-transparent"
                    onClick={togglePasswordVisibility}
                  >
                    {showPassword ? (
                      <img src={EyesOnIcon} className="eyes-icon" alt="" />
                    ) : (
                      <img src={EyesOffIcon} className="eyes-icon" alt="" />
                    )}
                  </button>
                </div>
                {errors.password && (
                  <div className="invalid-feedback d-block">
                    {errors.password}
                  </div>
                )}
                <div className="forgot_password text-end">
                  <Link to="/forgotpassword">Forgot Password</Link>
                </div>
                <button className="login_form_btn mt-4" disabled={!checkedVal}>
                  Sign In
                </button>
                <div className="signup_text text-center mt-3">
                  Don’t have an account?{" "}
                  <span
                    onClick={() =>
                      navigate("/register", { state: { checkedVal } })
                    }
                    style={{ cursor: "pointer", textDecoration: 'underline' }}
                  >
                    Sign Up
                  </span>
                </div>
              </form>
            </div>
          </div>
        </div>
        <div id="mobile_view">
          <div className="container login_download_app mt-1">
            <h6>
              <img src="images/suffixes3.svg" className="suffixes3" alt="" />
              Please Download and Install Brigiz App
              <br />
              to Explore More features{" "}
              <img
                src="images/green-suf2.png"
                className="green-suf2"
                style={{
                  width: "168px",
                  height: "32px",
                  marginLeft: "-158px",
                }}
                alt=""
              />
            </h6>
          </div>
          <div className=" exp-download-btns mt-4">
            <button
              onClick={() => window.open(ANDROID_APP_LINK, "_")}
              style={{ background: "#292828" }}
            >
              <div className="g_pay_container ">
                <div className=" btn-img1">
                  <img src="images/play-button.svg" alt="" />
                </div>
                <div className=" btn-txt1">
                  <span>GET IT ON</span>
                  <p className="text-white m-0">Google Play</p>
                </div>
              </div>
            </button>
            <button
              onClick={() => window.open(IOS_APP_LINK, "_")}
              style={{ width: "180px", background: "#292828" }}
            >
              <div className="g_pay_container">
                <div className=" btn-img1">
                  <img src="images/apple.svg" />
                </div>
                <div className="col-md-9 btn-txt1">
                  <span>Download on the</span>
                  <p className="text-white m-0">App Store</p>
                </div>
              </div>
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

export default Login;
